
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "Sarah Johnson",
      company: "TechStart Solutions",
      role: "Marketing Director",
      content: "My Marketing Horizon transformed our Google Ads performance. We saw a 250% increase in qualified leads within just 3 months. Their expertise in campaign optimization is unmatched.",
      rating: 5,
      image: "https://public.readdy.ai/ai/img_res/046e1dd6efb2cb996e1300e24d650d06.jpg"
    },
    {
      name: "Michael Chen",
      company: "E-commerce Plus",
      role: "CEO",
      content: "The social media campaigns they created for us on Facebook and Instagram generated over $500K in revenue. Their understanding of audience targeting is incredible.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Asian%20businessman%20in%20suit%20smiling%20confidently%2C%20CEO%20corporate%20headshot%2C%20modern%20office%20background%20with%20professional%20lighting%2C%20business%20executive%20portrait&width=100&height=100&seq=testimonial-2&orientation=squarish"
    },
    {
      name: "Emily Rodriguez",
      company: "Local Services Co",
      role: "Operations Manager",
      content: "Working with My Marketing Horizon was a game-changer. Their native advertising campaigns on Outbrain brought us high-quality traffic that actually converts.",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Hispanic%20businesswoman%20smiling%20warmly%2C%20operations%20manager%20headshot%2C%20clean%20office%20background%20with%20soft%20professional%20lighting%2C%20corporate%20portrait%20style&width=100&height=100&seq=testimonial-3&orientation=squarish"
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">What Our Clients Say</h2>
          <p className="text-xl text-gray-600">
            Don't just take our word for it - hear from businesses we've helped grow
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-orange-500 text-lg"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 italic">
                "{testimonial.content}"
              </p>
              <div className="flex items-center">
                <img 
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="w-12 h-12 rounded-full object-cover mr-4"
                />
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                  <div className="text-sm text-orange-500">{testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
